import {ID, QUERIES, Response} from '../../../../../../_metronic/helpers'
import {Account} from '../../../account/accounts-list/core/_models'
import {User} from '../../../account/accounts-list/core/_models'
import {Enrollment} from '../../../enrollment/enrollments-list/core/_models'
import {StudentType} from '../../../student-type/student-types-list/core/_models'
import {FieldProps, FieldTProps} from '../../../../../../_component/Form'
// import {promiseOptions} from '../../../../../../_component/address'

export type Admission = {
  id?: ID
  admission_no?: string
  admission_date?: Date
  relation_with_guardian?: string
  registration_no?: string
  group?: string
  is_library_member?: boolean
  is_hostel_member?: boolean
  is_transport_member?: boolean
  previous_school?: string
  previous_class?: string
  transfer_certificate?: string
  status?: 'regular' | 'drop' | 'transfer' | 'passed' | 'new' | 'waiting' | 'declined' | 'approved'
  created_at?: Date
  updated_at?: Date
  deleted_at?: Date
  created_by?: string
  updated_by?: string
  father_id?: number
  mother_id?: number
  guardian_id?: number
  account_id?: number
  school_id?: string
  student_type_id?: number
  discount_id?: number
  enrollment_id?: number
  account?: Account
  father?: User
  mother?: User
  guardian?: User
  enrollment?: Enrollment
  student_type?: StudentType
  account_user_image_to_upload?: File
  guardian_image_to_upload?: File
  father_image_to_upload?: File
  mother_image_to_upload?: File
  transfer_certificate_to_upload?: File
}

export type AdmissionsQueryResponse = Response<Array<Admission>>

const validateGuardian = (values: any, field: string) =>
  !['father', 'mother'].includes(values?.relation_with_guardian) ||
  (values?.relation_with_guardian === 'father' && !values?.father?.[field]) ||
  (values?.relation_with_guardian === 'mother' && !values?.mother?.[field])

export const fields: (formik?: any) => FieldTProps[] = (formik) => {
  const flds: any = [
    {
      title: 'Student Info',
      fields: [
        {
          name: 'user',
          label: 'Name',
          sortField: 'user.first_name',
          sortable: true,
          table: true,
          type: 'user_info',
          view: false,
          edit: false,
          create: false,
        },
        {
          name: 'user.email',
          label: 'Email',
          type: 'email',
          createField: 'user.email',
          helpText:
            'If your email is already registered, the system will link the application to your existing account.',
          export: true,
        },
        {
          name: 'user.first_name',
          label: 'First Name',
          required: true,
          export: true,
        },
        {
          name: 'user.last_name',
          label: 'Last Name',
          required: true,
          export: true,
        },
        {name: 'user.other_name', label: 'Other Name', type: 'text', export: true},
        {
          name: 'user.phone',
          label: 'Phone',
          export: true,
        },
        {
          name: 'user.gender',
          label: 'Gender',
          type: 'select',
          options: [
            {label: 'Male', value: 'male'},
            {label: 'Female', value: 'female'},
          ],
          required: true,
          export: true,
        },
        {
          name: 'user.birthday',
          label: 'Date of Birth',
          type: 'date',

          initialValue: '',
          export: true,
        },
        {
          name: 'user.blood_group',
          label: 'Blood Group',
          type: 'select',
          options: [
            {label: 'A+', value: 'A+'},
            {label: 'A-', value: 'A-'},
            {label: 'B+', value: 'B+'},
            {label: 'B-', value: 'B-'},
            {label: 'AB+', value: 'AB+'},
            {label: 'AB-', value: 'AB-'},
            {label: 'O+', value: 'O+'},
            {label: 'O-', value: 'O-'},
          ],
          export: true,
        },
        {
          name: 'user.religion',
          label: 'Religion',
          type: 'select',
          options: [
            {label: 'Christianity', value: 'CHRISTIANITY'},
            {label: 'Islam', value: 'ISLAM'},
            {label: 'Prefer not to say', value: 'PREFER_NOT_TO_SAY'},
          ],
          export: true,
        },
        {name: 'user.caste', label: 'Caste', type: 'text', export: true},
        {name: 'user.national_id', label: 'National ID', type: 'text', export: true},
        {
          name: 'user.image',
          label: 'Image',
          type: 'image',
          required: false,
          table: false,
          sortable: false,
          export: true,
        },
        {
          name: 'user.address1',
          label: 'Present Address',
          type: 'textarea',
          required: true,
        },
        {name: 'user.address2', label: 'Permanent Address', type: 'textarea'},
        // {
        //   name: 'user.address1',
        //   label: 'Present Address',
        //   type: 'address',
        //   required: true,
        //   searchFn: promiseOptions,
        //   export: true,
        // },
        // {
        //   name: 'user.address2',
        //   label: 'Permanent Address',
        //   type: 'address',
        //   searchFn: promiseOptions,
        //   export: true,
        // },
      ],
    },
    {
      title: 'Father Info',
      fields: [
        {
          name: 'father.email',
          label: 'Father Email',
          type: 'email',
          export: true,
        },
        {
          name: 'father.first_name',
          label: 'Father First Name',
          type: 'text',
          required: true,
          export: true,
        },
        {
          name: 'father.last_name',
          label: 'Father Last Name',
          type: 'text',
          required: true,
          export: true,
        },
        {name: 'father.phone', label: 'Father Phone', type: 'text', export: true},
        {
          name: 'father.highest_education',
          label: 'Father Highest Education',
          type: 'text',
          export: true,
        },
        {name: 'father.profession', label: 'Father Profession', type: 'text', export: true},
        {
          name: 'father.image',
          label: 'Father Image',
          type: 'image',
          export: true,
        },
      ],
    },
    {
      title: 'Mother Info',
      fields: [
        {
          name: 'mother.email',
          label: 'Mother Email',
          type: 'email',
          export: true,
        },
        {
          name: 'mother.first_name',
          label: 'Mother First Name',
          type: 'text',
          required: true,
          export: true,
        },
        {
          name: 'mother.last_name',
          label: 'Mother Last Name',
          type: 'text',
          required: true,
          export: true,
        },
        {name: 'mother.phone', label: 'Mother Phone', type: 'text', export: true},
        {
          name: 'mother.highest_education',
          label: 'Mother Highest Education',
          type: 'text',
          export: true,
        },
        {name: 'mother.profession', label: 'Mother Profession', type: 'text', export: true},
        {
          name: 'mother.image',
          label: 'Mother Image',
          type: 'image',
          export: true,
        },
      ],
    },
    {
      title: 'Guardian Info',
      fields: [
        {
          name: 'relation_with_guardian',
          label: 'Relationship With Student',
          type: 'select',
          required: true,
          options: [
            {label: 'Father', value: 'father'},
            {label: 'Mother', value: 'mother'},
            {label: 'Other', value: 'other'},
          ],
          export: true,
        },
        {
          name: 'guardian.email',
          label: 'Guardian Email',
          type: 'email',
          create: validateGuardian(formik?.values, 'email'),
          edit: validateGuardian(formik?.values, 'email'),
          export: true,
        },
        {
          name: 'guardian.first_name',
          label: 'Guardian First Name',
          type: 'text',
          create: validateGuardian(formik?.values, 'first_name'),
          edit: validateGuardian(formik?.values, 'first_name'),
          export: true,
        },
        {
          name: 'guardian.last_name',
          label: 'Guardian Last Name',
          type: 'text',
          create: validateGuardian(formik?.values, 'last_name'),
          edit: validateGuardian(formik?.values, 'last_name'),
          export: true,
        },
        {
          name: 'guardian.phone',
          label: 'Guardian Phone',
          type: 'text',
          create: validateGuardian(formik?.values, 'phone'),
          edit: validateGuardian(formik?.values, 'phone'),
          export: true,
        },
        {
          name: 'guardian.national_id',
          label: 'National ID',
          type: 'text',
          create: validateGuardian(formik?.values, 'national_id'),
          edit: validateGuardian(formik?.values, 'national_id'),
          export: true,
        },
        {
          name: 'guardian.highest_education',
          label: 'Highest Education',
          type: 'text',
          create: validateGuardian(formik?.values, 'highest_education'),
          edit: validateGuardian(formik?.values, 'highest_education'),
          export: true,
        },
        {
          name: 'guardian.profession',
          label: 'Profession',
          type: 'text',
          create: validateGuardian(formik?.values, 'profession'),
          edit: validateGuardian(formik?.values, 'profession'),
          export: true,
        },
        {
          name: 'guardian.image',
          label: 'Guardian Image',
          type: 'image',
          create: validateGuardian(formik?.values, 'image'),
          edit: validateGuardian(formik?.values, 'image'),
          export: true,
        },
        {
          name: 'guardian.same_as_student_address',
          label: 'Same as student address?',
          type: 'switch',
          full: true,
          initialValue: false,
          export: true,
        },
        {
          name: 'guardian.address1',
          label: 'Guardian Present Address',
          type: 'textarea',
          create: !formik?.values?.guardian?.same_as_student_address,
          edit: !formik?.values?.guardian?.same_as_student_address,
          // searchFn: promiseOptions,
          export: true,
        },
        {
          name: 'guardian.address2',
          label: 'Guardian Permanent Address',
          type: 'textarea',
          create: !formik?.values?.guardian?.same_as_student_address,
          edit: !formik?.values?.guardian?.same_as_student_address,
          // searchFn: promiseOptions,
          export: true,
        },
      ],
    },
    {
      title: 'Enrollment Info',
      fields: [
        {
          name: 'registration_no',
          label: 'Registration Number',
          required: false,
          table: true,
          sortable: true,
          hidden: true,
          export: true,
        },
        {
          name: 'temp_password',
          label: 'Temp. Password',
          required: false,
          table: true,
          create: false,
          edit: false,
          export: true,
        },
        {
          name: 'student_type_id',
          label: 'Student Type',
          viewName: 'student_type.type',
          type: 'select',
          optionsQuery: {
            queryKey: ['student-type', 'filter={"status":true}'],
            enabled: true,
            name: 'type',
          },
          required: true,
          export: true,
          filter: 4,
        },
        {
          name: 'group',
          label: 'Group',
          type: 'select',
          options: [
            {label: 'Science', value: 'science'},
            {label: 'Art', value: 'art'},
            {label: 'Commerce', value: 'commerce'},
          ],
          export: true,
        },
        {
          name: 'class_id',
          label: 'Class',
          viewName: 'class.name',
          type: 'select',
          optionsQuery: {
            queryKey: [QUERIES.CLASSES_LIST, 'filter={"status":true}'],
            enabled: true,
          },
          required: true,
          table: true,
          edit: false,
          export: true,
          filter: 2,
        },
        {
          name: 'section_id',
          label: 'Section',
          viewName: 'section.name',
          type: 'select',
          optionsQuery: {
            queryKey: [
              QUERIES.SECTIONS_LIST,
              `filter={"status":true,"class_id":"formik.values.class_id"}`,
            ],
          },
          export: true,
          filter: 3,
        },
        {
          name: 'previous_school',
          label: 'Previous School',
          type: 'text',
          export: true,
        },
        {
          name: 'previous_class',
          label: 'Previous Class',
          type: 'text',
          export: true,
        },
        {
          name: 'transfer_certificate',
          label: 'Transfer Certificate',
          type: 'file',
          accept: '.pdf, .doc, .docx, .ppt, .pptx',
          limit: 2048,
          export: true,
        },
        {
          name: 'status',
          label: 'Status',
          type: 'select',
          options: [
            {label: 'New', value: 'new'},
            {label: 'Waiting', value: 'waiting'},
            {label: 'Declined', value: 'declined'},
            {label: 'Approved', value: 'approved'},
          ],
          required: true,
          filter: 1,
          create: false,
          edit: false,
          table: true,
          export: true,
        },
      ],
    },
  ]
  let res: any = localStorage.getItem(QUERIES.ADMISSION_FIELD_LIST)
  if (res) res = JSON.parse(res.replaceAll('account.', ''))
  res?.forEach((item: any) => {
    flds.find((levels: any) => {
      const idx = levels.fields.findIndex(
        (field: any) => levels.title + ': ' + field.label === item.name
      )
      if (idx !== -1) {
        if (item.hasOwnProperty('status')) {
          levels.fields[idx].create = item.status
          levels.fields[idx].edit = item.status
          levels.fields[idx].view = item.status
        }
        levels.fields[idx].required = item.required ?? levels.fields[idx].required
        return true
      }
      return false
    })
  })
  return flds
}

export const admitFields: FieldProps[] = [
  {
    name: 'class_id',
    label: 'Class',
    viewName: 'class.name',
    type: 'select',
    optionsQuery: {
      queryKey: [QUERIES.CLASSES_LIST, 'filter={"status":true}'],
      enabled: true,
    },
    required: true,
  },
  {
    name: 'section_id',
    label: 'Section',
    viewName: 'section.name',
    type: 'select',
    optionsQuery: {
      queryKey: [
        QUERIES.SECTIONS_LIST,
        `filter={"status":true,"class_id":"formik.values.class_id"}`,
      ],
    },
    required: true,
  },
  {
    name: 'admission_no',
    label: 'Admission Number',
    type: 'text',
    required: false,
  },
  {
    name: 'roll_no',
    label: 'Roll Number',
    type: 'text',
    required: false,
  },
]
